import * as actions from '../services'
import * as types from './mutations-types'
import { t } from 'src/utils/form'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { setSeller } from 'src/app/pages/auth/vuex/mutations-types'

export const loadUser = (context) => {
  return actions.getUser()
  .then(function (response) {
    if (response === undefined) {
      return response
    }
    if (response && response.status === 200 || response.status === 304) {
      context.commit(types.setUser, response.data.user)
    }
    return response
  })
}

export const editSeller = (context, payload) => {
  var onlyNumber = /[\D]/g
  if (payload.seller !== undefined && payload.seller.address_attributes !== undefined) {
    payload.seller.address_attributes.postal_code = payload.seller.address_attributes.postal_code.replace(onlyNumber, '')
  }
  return actions.updateSeller({ seller: payload.seller })
  .then(function (response) {
    if (response && response.status === 200 || response.status === 304) {
      if (payload.message) {
        context.commit(addFlash, { message: t(context, 'application.alert.changes_have_been_saved'), type: 'ls-alert-success' })
      }
      context.commit(setSeller, response.data.seller)
    }
    return response
  })
}

export const checkUsername = (context, username) => {
  return actions.validateUsername(username)
  .then(function (response) {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/pages/wizard/vuex/actions.js